module.exports = __webpack_public_path__ + "media/base/circle_alert-c6c0a0df.svg";